import {
  ChangeDetectorRef,
  Directive,
  ElementRef,
  Input,
  Renderer2,
} from '@angular/core';
import { EMPTY, fromEvent, merge, of } from 'rxjs';
import { ContentService } from '../core/content.service';
import { EventsService } from '../core/events.service';
import { HookDirective } from '../core/hook';
import { useInit, useSubscriptionLatest } from '../core/hooks';
import { SizeService } from '../core/size.service';

@Directive({ selector: '[scrollBorder]', providers: [SizeService] })
export class ScrollBorderDirective extends HookDirective {
  @Input()
  scrollBorderTop = true;

  @Input()
  scrollBorderBottom = true;

  constructor(
    private readonly contentService: ContentService,
    private readonly eventsService: EventsService,
    private readonly renderer: Renderer2,
    private readonly element: ElementRef<HTMLElement>,
    changeDetector: ChangeDetectorRef,
  ) {
    super(changeDetector);
  }

  get _() {
    const scroll = useInit(() =>
      merge(
        of(undefined),
        this.eventsService.resize,
        this.contentService.observe(this.element.nativeElement),
        fromEvent(this.element.nativeElement, 'scroll'),
      ),
    );

    useSubscriptionLatest(
      this.scrollBorderTop || this.scrollBorderBottom ? scroll : EMPTY,
      [],
    );

    if (this.scrollBorderTop && scrolledTop(this.element.nativeElement)) {
      this.renderer.addClass(this.element.nativeElement, 'rv-scrolled-top');
    } else {
      this.renderer.removeClass(this.element.nativeElement, 'rv-scrolled-top');
    }

    if (this.scrollBorderBottom && scrolledBottom(this.element.nativeElement)) {
      this.renderer.addClass(this.element.nativeElement, 'rv-scrolled-bottom');
    } else {
      this.renderer.removeClass(
        this.element.nativeElement,
        'rv-scrolled-bottom',
      );
    }

    return;
  }
}

function scrolledTop(element: HTMLElement) {
  return 0 < element.scrollTop;
}

function scrolledBottom(element: HTMLElement) {
  return element.scrollTop + element.offsetHeight < element.scrollHeight;
}
